import { connect } from 'react-redux';

import { selectIsCpcOffer } from 'shared/selectors';
import { selectUserType } from 'shared/selectors/user';
import { EUserType } from 'shared/types/user';

import { IOfferValueAddedServicesProps, OfferValueAddedServices } from './index';
import { isMlSearchEnabled } from '../../selectors/isMlSearchEnabled';
import { IState } from '../../store';

export const mapStateToProps = (state: IState): IOfferValueAddedServicesProps => {
  return {
    valueAddedServices: state.offerData.offer.valueAddedServices,
    isMlSearchEnabled: isMlSearchEnabled(state),
    isPerformanceVasPilot: state.rs.isPerformanceVasPilot,
    shouldShowPromotionByUserType: selectUserType(state) !== EUserType.Undefined,
    isCpcOffer: selectIsCpcOffer(state),
  };
};

export const OfferValueAddedServicesContainer =
  connect<IOfferValueAddedServicesProps>(mapStateToProps)(OfferValueAddedServices);
